import "./App.css";
import { useState } from "react";

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const togglePrivacyPolicy = () => {
    setShowPrivacyPolicy(!showPrivacyPolicy);
  };

  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Obxcyber - Protecting businesses from digital threats with tailored cybersecurity solutions" 
          style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }} 
        />
        <p className="eyebrow">Obxcyber · Cybersecurity Solutions</p>
        <h1>Protect Your Business from Digital Threats</h1>
        <p className="lede">
          Tailored cybersecurity solutions designed to safeguard your business and manage risks effectively.
        </p>
        <div className="cta-row">
          <button onClick={() => window.location.href='/get-quote'}>Get a Free Quote</button>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Cybersecurity Best Practices</h2>
          <p>
            Stay informed about the latest strategies to protect your business from evolving digital threats.
          </p>
        </article>
        <article>
          <h2>Risk Assessment Techniques</h2>
          <p>
            Identify vulnerabilities and implement effective measures to mitigate risks in your organization.
          </p>
        </article>
        <article>
          <h2>Incident Response Planning</h2>
          <p>
            Prepare your team with a robust incident response plan to minimize damage and recover swiftly from attacks.
          </p>
        </article>
      </section>

      <footer>
        <button onClick={togglePrivacyPolicy}>Privacy Policy</button>
      </footer>

      {showPrivacyPolicy && (
        <section className="privacy-policy">
          <h2>Privacy Policy</h2>
          <p>
            At Obxcyber, we are committed to protecting your privacy. We collect data to provide better services to our users. This includes information about your interactions with our website, such as analytics data and cookies.
          </p>
          <p>
            We may use third-party vendors, including Google AdSense, who may use cookies to serve ads based on your prior visits to our site or other sites on the internet. You can learn more about how to manage your ad settings by visiting <a href="https://myaccount.google.com/data-and-privacy" target="_blank">Google's ad settings</a>.
          </p>
          <p>
            If you have any questions about our privacy practices, please contact us at privacy@obxcyber.com.
          </p>
        </section>
      )}
    </div>
  );
}

export default App;